<template>
  <div>
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <p v-if="state.noData">No Data</p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <h2 class="report-title">LAPORAN PISAH CONTAINER</h2>
      </div>

      <table width="100%" class="mt-4">
        <thead>
          <th class="text-left">Kode TTB</th>
          <th class="text-left">No TTB</th>
          <th class="text-left">Tanggal TTB</th>
          <th class="text-right">Total Koli TTB</th>
          <th class="text-right">Koli Masuk Container</th>
          <th class="text-right">Selisih</th>
          <th class="text-left">Kode Container</th>
          <th class="text-left">KV</th>
          <th class="text-left">Nama Kapal</th>
          <th class="text-left">Voyage</th>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in data" :key="idx">
            <td>{{ item.kodettb }}</td>
            <td>{{ item.nottb || "-" }}</td>
            <td>{{ formatDate(item.tgl) }}</td>
            <td class="text-right">{{ item.total_koli_ttb }}</td>
            <td class="text-right">{{ item.koli_masuk_container }}</td>
            <td class="text-right">{{ item.selisih }}</td>
            <td>{{ item.kc }}</td>
            <td>{{ item.kv || "-" }}</td>
            <td>{{ item.nama_kapal }}</td>
            <td>{{ item.voy }}</td>
          </tr>
        </tbody>
      </table>
    </main>

    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      data: []
    };
  },
  methods: {
    async fetchData() {
      this.state.loading = true;

      await axios
        .get("laporan/pisah-container")
        .then(res => {
          if (!res.data || res.data.length === 0) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;
          alert(err.response?.data?.message || "Gagal memuat laporan");
        });
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return "-";
      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    },
    printDocument() {
      window.print();
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}
</style>
